import React from "react";
import { Link } from "react-router-dom";
import SeoHead from "../components/SeoHead";
import { BUSINESS_INFO, PRODUCTS_AND_EQUIPMENT } from "../data";

export default function OmOs() {
  return (
    <>
      <SeoHead
        title="Om os – Hvem står bag Ses Multi Service"
        description="Lær Sofia Emmy Skafsgaard at kende. Over 10 års erfaring med rengøring og uddannet rengøringsleder fra TEC Odense. Sommerhusrengøring og hundeklip i Norddjurs."
        path="/om-os"
      />

      {/* HERO SECTION */}
      <section className="bg-gradient-to-b from-[#F4EFE6] to-[#FAF7F2] py-12 lg:py-16 border-b border-[#EADFCF]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center max-w-3xl">
          <div className="inline-flex items-center gap-2 bg-[#EADFCF] text-[#4B3C2D] px-3.5 py-1 rounded-full text-xs font-semibold mb-3">
            <i className="fa-solid fa-user-tie text-[#887055]" aria-hidden="true"></i>
            <span>Mød ejeren bag Ses Multi Service</span>
          </div>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold font-heading text-[#2C2523]">
            Hvem står bag Ses Multi Service?
          </h1>
          <p className="text-base text-[#5C524C] mt-3 leading-relaxed">
            Personlig betjening, mange års professionel rengøringserfaring og et stort engagement i lokalområdet.
          </p>
        </div>
      </section>

      {/* STORY & DETAILS SECTION */}
      <section className="py-14 lg:py-20 bg-[#FAF7F2]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-start">
            
            {/* Main Story (Left Column) */}
            <div className="lg:col-span-7 space-y-6">
              <div className="bg-[#FFFDF9] rounded-3xl p-8 sm:p-10 border border-[#EADFCF] shadow-xs space-y-6">
                
                <div className="border-b border-[#EADFCF] pb-4">
                  <h2 className="text-2xl sm:text-3xl font-bold font-heading text-[#2C2523]">
                    Sofia Emmy Skafsgaard
                  </h2>
                  <p className="text-sm font-semibold text-[#887055] mt-1">
                    Indehaver af Ses Multi Service
                  </p>
                </div>

                <div className="space-y-4 text-base text-[#3A302B] leading-relaxed">
                  <p className="font-medium text-lg text-[#2C2523]">
                    Jeg hedder Sofia Emmy Skafsgaard, 62 år, gift.<br />
                    Mor til 4 og har 8 børnebørn
                  </p>

                  <p>
                    Siden 2004-2008 har jeg været uddannet social- og sundhedshjælper og assistent.
                  </p>

                  <p>
                    Jeg har fra 2014 til 2025 haft rengøringsfirmaet Ses Super Ren som startede op i Ørum ved Viborg og ved vores flytning til Vejle / Fredericia i 2017, hvor jeg startede med at have nye kunder der.
                  </p>

                  <p>
                    Jeg tog i sommeren 2024 rengøringsleder uddannelsen på TEC Odense.
                  </p>

                  <p>
                    Ses Super Ren er solgt til Anastasia, som var en af mine medarbejdere, som har kørt det videre i samme ånd.
                  </p>

                  {/* Trustpilot Review Box */}
                  <div className="bg-[#FAF7F2] p-5 rounded-2xl border border-[#D8C7B0] space-y-2.5 my-4">
                    <div className="flex items-center justify-between flex-wrap gap-2">
                      <div className="flex items-center gap-2 text-[#00B67A] font-bold text-sm">
                        <i className="fa-solid fa-star" aria-hidden="true"></i>
                        <span>Anmeldelser på Trustpilot</span>
                      </div>
                      <a
                        href="https://www.trustpilot.com/review/sessuperren.dk"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="bg-[#2C2523] hover:bg-black text-white text-xs font-semibold px-4 py-2 rounded-xl transition-colors inline-flex items-center gap-1.5"
                      >
                        <span>Gå til Trustpilot</span>
                        <i className="fa-solid fa-arrow-up-right-from-square text-[10px]" aria-hidden="true"></i>
                      </a>
                    </div>
                    <p className="text-xs sm:text-sm text-[#5C524C]">
                      På Trustpilot kan du læse hvad kunderne siger – alt før 1. okt. 2025 handler om den service, jeg har givet kunderne.
                    </p>
                  </div>

                  <p>
                    Jeg vil gøre mit bedste for at give dit sommerhus en ny friskhed, så du kan have tilfredse kunder som lejer dit sommerhus. Så de kan have fokus på at holde ferie og ikke på om der er gjort godt nok rent.
                  </p>

                  <p>
                    Jeg har haft private / erhvervskunder fra 1 time om ugen til 25 timer om ugen.
                  </p>

                  <p>
                    Jeg arbejdede en del år med sommerhus rengøring i Høll, Hvidbjerg og Mørkholt.
                  </p>

                  <p>
                    Jeg har arbejdet på Skive Soldaterhjem som køkkenassistent. I en periode efter at jeg har solgt firmaet Ses Super Ren.
                  </p>
                </div>

              </div>
            </div>

            {/* Right Column: "Nu er jeg startet op igen" and quick facts */}
            <div className="lg:col-span-5 space-y-6">
              
              <div className="bg-[#F4EFE6] rounded-3xl p-8 border border-[#EADFCF] space-y-6 shadow-xs">
                <div className="flex items-center gap-3 border-b border-[#D8C7B0] pb-4">
                  <div className="w-10 h-10 rounded-xl bg-[#3A302B] text-white flex items-center justify-center text-lg shrink-0">
                    <i className="fa-solid fa-repeat" aria-hidden="true"></i>
                  </div>
                  <h3 className="text-xl font-bold font-heading text-[#2C2523]">
                    Nu er jeg startet op igen:
                  </h3>
                </div>

                <ul className="space-y-4 text-sm text-[#4A403A]">
                  <li className="flex items-start gap-3">
                    <i className="fa-solid fa-circle-check text-[#887055] mt-1 shrink-0" aria-hidden="true"></i>
                    <span>Savnede kundekontakten og fandt ud af at der er et behov for den hjælp som jeg kan tilbyde med rengøring af sommerhuse og hundeklip.</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="fa-solid fa-circle-check text-[#887055] mt-1 shrink-0" aria-hidden="true"></i>
                    <span>Jeg udfører alle opgaverne som det er nu men håber på at få så travlt at jeg kan ansætte nogle nye medarbejdere.</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="fa-solid fa-location-dot text-[#887055] mt-1 shrink-0" aria-hidden="true"></i>
                    <span><strong>Dækningsområde:</strong> Jeg kører primært i Ørsted, Allingåbro og Fjellerup området.</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="fa-solid fa-circle-check text-[#887055] mt-1 shrink-0" aria-hidden="true"></i>
                    <span>Jeg har alt udstyret med til rengøring af dit sommerhus, Jeg ser frem til at komme forbi dit sommerhus med et uforpligtende tilbud.</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="fa-solid fa-paw text-[#887055] mt-1 shrink-0" aria-hidden="true"></i>
                    <span>Hundebad og klip foregår på vores private adr.</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="fa-solid fa-circle-check text-[#887055] mt-1 shrink-0" aria-hidden="true"></i>
                    <span>Ind imellem har jeg også et par udekørende vagter i hjemmeplejen Allingåbro.</span>
                  </li>
                </ul>

                <div className="pt-4 border-t border-[#D8C7B0] space-y-4">
                  <p className="font-semibold text-sm text-[#2C2523]">
                    Jeg ser frem til at høre fra dig i forhold til Rengøringsopgaven eller hundeklip
                  </p>
                  
                  <div className="flex flex-col sm:flex-row gap-3">
                    <a
                      href={`tel:${BUSINESS_INFO.phone}`}
                      className="bg-[#3A302B] hover:bg-[#231C19] text-white text-xs sm:text-sm font-semibold px-5 py-3 rounded-xl transition-colors flex items-center justify-center gap-2 whitespace-nowrap"
                    >
                      <i className="fa-solid fa-phone text-xs" aria-hidden="true"></i>
                      <span>Ring {BUSINESS_INFO.phoneFormatted}</span>
                    </a>
                    <Link
                      to="/kontakt"
                      className="bg-[#EADFCF] hover:bg-[#D8C7B0] text-[#2C2523] text-xs sm:text-sm font-semibold px-5 py-3 rounded-xl transition-colors flex items-center justify-center gap-2 border border-[#D8C7B0]"
                    >
                      <i className="fa-solid fa-paper-plane text-xs text-[#887055]" aria-hidden="true"></i>
                      <span>Kontakt mig</span>
                    </Link>
                  </div>
                </div>
              </div>

              {/* Badges */}
              <div className="bg-[#FFFDF9] rounded-2xl p-6 border border-[#EADFCF] space-y-3">
                <h4 className="text-sm font-bold text-[#2C2523] uppercase tracking-wider">Erfaring & Tryghed</h4>
                <div className="space-y-2 text-xs text-[#5C524C]">
                  <p className="flex items-center gap-2">
                    <i className="fa-solid fa-check text-[#887055]"></i>
                    <span>Uddannet social- og sundhedshjælper/assistent (2004-2008)</span>
                  </p>
                  <p className="flex items-center gap-2">
                    <i className="fa-solid fa-check text-[#887055]"></i>
                    <span>Grundlægger af Ses Super Ren (2014-2025)</span>
                  </p>
                  <p className="flex items-center gap-2">
                    <i className="fa-solid fa-check text-[#887055]"></i>
                    <span>Uddannet Rengøringsleder på TEC Odense (2024)</span>
                  </p>
                </div>
              </div>

            </div>

          </div>
        </div>
      </section>

      {/* WHY CHOOSE SES MULTI SERVICE SECTION */}
      <section className="py-16 lg:py-24 bg-[#F4EFE6] border-y border-[#EADFCF]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12">
          
          <div className="text-center max-w-2xl mx-auto space-y-3">
            <span className="text-xs font-bold uppercase tracking-widest text-[#887055]">
              Samarbejde & Standarder
            </span>
            <h2 className="text-3xl sm:text-4xl font-bold font-heading text-[#2C2523] tracking-tight">
              Hvorfor Ses Multi Service?
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
            
            {/* Kvalitet */}
            <div className="bg-[#FFFDF9] rounded-2xl p-8 border border-[#EADFCF] shadow-xs">
              <div className="w-12 h-12 rounded-xl bg-[#EADFCF] text-[#6B5640] flex items-center justify-center text-xl mb-4">
                <i className="fa-solid fa-sparkles" aria-hidden="true"></i>
              </div>
              <h3 className="text-xl font-bold font-heading text-[#2C2523] mb-3">
                Kvalitet:
              </h3>
              <p className="text-sm sm:text-base text-[#5C524C] leading-relaxed">
                Aftaleprocessen med os er både hurtig og nem. Du kan nemt finde den tid, der passer dig bedst, og vi sørger for at imødekomme dine behov. Vi værdsætter din tid og stræber efter at gøre det så enkelt som muligt for dig.
              </p>
            </div>

            {/* Kontakt */}
            <div className="bg-[#FFFDF9] rounded-2xl p-8 border border-[#EADFCF] shadow-xs">
              <div className="w-12 h-12 rounded-xl bg-[#EADFCF] text-[#6B5640] flex items-center justify-center text-xl mb-4">
                <i className="fa-solid fa-file-signature" aria-hidden="true"></i>
              </div>
              <h3 className="text-xl font-bold font-heading text-[#2C2523] mb-3">
                Kontakt:
              </h3>
              <p className="text-sm sm:text-base text-[#5C524C] leading-relaxed">
                Der oprettes en kontakt for hver kundeaftale, hvor frekvensen for opgavens udførelse, samt den aftalte pris, dokumenteres. Denne procedure sikrer, at begge parter er enige om vilkårene og mindsker risikoen for misforståelser. Det er vigtigt at holde disse oplysninger opdaterede for at sikre en optimal samarbejdsrelation.
              </p>
            </div>

            {/* Henvendelse */}
            <div className="bg-[#FFFDF9] rounded-2xl p-8 border border-[#EADFCF] shadow-xs">
              <div className="w-12 h-12 rounded-xl bg-[#EADFCF] text-[#6B5640] flex items-center justify-center text-xl mb-4">
                <i className="fa-solid fa-comments" aria-hidden="true"></i>
              </div>
              <h3 className="text-xl font-bold font-heading text-[#2C2523] mb-3">
                Henvendelse:
              </h3>
              <p className="text-sm sm:text-base text-[#5C524C] leading-relaxed">
                Vi er fleksible, hurtige til at besvare henvendelser og effektive i vores arbejde. Vores fokus er altid på at levere et flot resultat, der imødekommer dine behov. Din tilfredshed er vores prioritet, og vi stræber efter at overgå dine forventninger.
              </p>
            </div>

            {/* Bestilling af flere ydelser */}
            <div className="bg-[#FFFDF9] rounded-2xl p-8 border border-[#EADFCF] shadow-xs">
              <div className="w-12 h-12 rounded-xl bg-[#EADFCF] text-[#6B5640] flex items-center justify-center text-xl mb-4">
                <i className="fa-solid fa-list-check" aria-hidden="true"></i>
              </div>
              <h3 className="text-xl font-bold font-heading text-[#2C2523] mb-3">
                Bestilling af flere ydelser
              </h3>
              <p className="text-sm sm:text-base text-[#5C524C] leading-relaxed">
                En kunde kan bestille flere forskellige ydelser. Bestillingsprocessen foregår typisk ved, at kunden vælger de ønskede ydelser fra vores udvalg, og der bliver udtrykt dette ved det uforpligtende besøg fra Ses Multi Service.  Der bliver lavet kontrakt på hver opgave.
                <br className="my-2" />
                Hvis der er spørgsmål omkring bestillingen, kan kunden altid kontakte Ses Multi Service for hjælp.
              </p>
            </div>

          </div>

        </div>
      </section>

      {/* PRODUCTS & EQUIPMENT SECTION */}
      <section className="py-16 lg:py-24 bg-[#FAF7F2]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-[#FFFDF9] rounded-3xl p-8 sm:p-12 border border-[#EADFCF] shadow-xs">
            <div className="max-w-3xl mb-10 space-y-4">
              <div className="inline-flex items-center gap-2 bg-[#EADFCF] text-[#4B3C2D] px-3.5 py-1 rounded-full text-xs font-semibold">
                <i className="fa-solid fa-leaf text-[#887055]" aria-hidden="true"></i>
                <span>Udstyr & plejemidler</span>
              </div>
              <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold font-heading text-[#2C2523]">
                Miljøvenlige produkter og professionelt udstyr
              </h2>
              <div className="text-base sm:text-lg text-[#4A403A] leading-relaxed space-y-2">
                <p>{PRODUCTS_AND_EQUIPMENT.intro}</p>
                <p className="text-sm sm:text-base text-[#5C524C]">{PRODUCTS_AND_EQUIPMENT.subIntro}</p>
              </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              {/* Cleaning Products */}
              <div className="bg-[#FAF7F2] rounded-2xl p-6 sm:p-8 border border-[#EADFCF] flex flex-col justify-between">
                <div className="space-y-4">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-xl bg-[#EADFCF] text-[#6B5640] flex items-center justify-center text-lg shrink-0">
                      <i className="fa-solid fa-sparkles" aria-hidden="true"></i>
                    </div>
                    <h3 className="text-lg sm:text-xl font-bold font-heading text-[#2C2523]">
                      {PRODUCTS_AND_EQUIPMENT.cleaningHeading}
                    </h3>
                  </div>
                  <p className="text-xs sm:text-sm text-[#5C524C]">
                    Miljøvenlige rengøringsprodukter og professionelt udstyr:
                  </p>
                  <ul className="space-y-3 pt-2">
                    {PRODUCTS_AND_EQUIPMENT.cleaningLinks.map((item, idx) => (
                      <li key={idx}>
                        <a
                          href={item.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="flex items-center justify-between p-3.5 rounded-xl bg-white border border-[#EADFCF] hover:border-[#887055] hover:bg-[#FFFDF9] transition-all group"
                        >
                          <span className="font-semibold text-sm text-[#2C2523] group-hover:text-[#887055] transition-colors">
                            {item.url}
                          </span>
                          <i className="fa-solid fa-arrow-up-right-from-square text-xs text-[#887055] group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" aria-hidden="true"></i>
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              {/* Dog Grooming Products */}
              <div className="bg-[#FAF7F2] rounded-2xl p-6 sm:p-8 border border-[#EADFCF] flex flex-col justify-between">
                <div className="space-y-4">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-xl bg-[#EADFCF] text-[#6B5640] flex items-center justify-center text-lg shrink-0">
                      <i className="fa-solid fa-paw" aria-hidden="true"></i>
                    </div>
                    <h3 className="text-lg sm:text-xl font-bold font-heading text-[#2C2523]">
                      {PRODUCTS_AND_EQUIPMENT.dogCareHeading}
                    </h3>
                  </div>
                  <p className="text-xs sm:text-sm text-[#5C524C]">
                    Skånsom og kærlig pleje med milde kvalitetsprodukter:
                  </p>
                  <ul className="space-y-3 pt-2">
                    {PRODUCTS_AND_EQUIPMENT.dogCareLinks.map((item, idx) => (
                      <li key={idx}>
                        <a
                          href={item.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="flex items-center justify-between p-3.5 rounded-xl bg-white border border-[#EADFCF] hover:border-[#887055] hover:bg-[#FFFDF9] transition-all group"
                        >
                          <span className="font-semibold text-sm text-[#2C2523] group-hover:text-[#887055] transition-colors">
                            {item.url}
                          </span>
                          <i className="fa-solid fa-arrow-up-right-from-square text-xs text-[#887055] group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" aria-hidden="true"></i>
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
}
